import {Auth} from "@/core/api/auth.api";

export default {
  async makeLogin({ dispatch, commit, getters, rootGetters }, {email, password}) {
    return await Auth.makeLogin({email, password})
  },

  async guestLogin({ dispatch, commit, getters, rootGetters }, nickname) {
    return await Auth.guestLogin(nickname)
  },

  async mobileTokenLogin({ dispatch, commit, getters, rootGetters }, token) {
    return await Auth.mobileTokenLogin(token)
  },

  async currentUser({ dispatch, commit, getters, rootGetters }) {
    return await Auth.currentUser()
  },

  async logout({ dispatch, commit, getters, rootGetters }) {
    return await Auth.logout()
  },
}
